const AUTH_ERROR_PATTERN = /invalid\s+(?:access\s+)?token|token\s+(?:has\s+)?expired|jwt|unauthori[sz]ed|authentication\s+(?:failed|required)/i;

export const isAuthenticationError = (error) => {
  const status = error?.response?.status || error?.statusCode || error?.status;
  const message = error?.response?.data?.message || error?.message || "";
  return status === 401 || AUTH_ERROR_PATTERN.test(Array.isArray(message) ? message.join(" ") : `${message}`);
};

export const getUserFacingError = (error, fallback = "Unable to complete this action.") => {
  if (isAuthenticationError(error)) return "Your session has expired. Please sign in again.";
  const rawMessage = error?.response?.data?.message || error?.message;
  const message = Array.isArray(rawMessage) ? rawMessage.join(", ") : rawMessage;
  return `${message || ""}`.trim() || fallback;
};
